/*jshint esversion: 6 */

// todo: after done try JavaScript Standard Style

const InputId = "statusInput";
//const OutputId = "StatusOutput";
const ReadyId = "readyStatus";
const TestId = "testStatus";
const NotReadyId = "notReadyStatus";
const NotFoundId = "notFoundStatus";

const CsvPath = "statuses.csv";

//const NotFoundAnswer = "ремонт с таким номером не найден";
//const EmptyAnswer = "введите номер ремонта";

/** @typedef {Object.<string, boolean>} Statuses */

/** @type {Statuses} */
var statuses = null;

function CheckStatus() {
  if (!statuses) {
    ParseAndThen(Answer);
  } else {
    Answer();
  }

  /** @param {function():void} callback */
  function ParseAndThen(callback) {
    /**
     * @param {object[]} array
     * @returns {Statuses}
     */
    function normalize(array) {
      /** @type {Statuses} */
      const dict = {};
      for (let i = 0; i < array.length; i++) {
        const key = array[i][0].toUpperCase();
        dict[key] = array[i][1];
      }
      console.log(dict);
      return dict;
    }

    if (window.location.protocol !== "file:") {
      Papa.parse(CsvPath, {
        download: true,
        dynamicTyping: true,
        complete: result => {
          statuses = normalize(result.data);
          callback();
        }
      });
    } else {
      statuses = normalize(
        Papa.parse("G1,true\nG2,false\nG3,true", { dynamicTyping: true })
          .data
      );
      callback();
    }
  }

  function Answer() {
    function getInput(id) {
      return /** @type {HTMLInputElement} */ (document.getElementById(id));
    }
    /**
     * @param {Statuses} statuses
     * @param {string} id
     */
    function produceAnswer(statuses, id) {
      let key = id.trim().toUpperCase();
      if (key) {
        // return statuses[key] || NotFoundAnswer;
        switch (statuses[key]) {
          case true:
            //return "Готов";
            return ReadyId;
          case false:
            //return "Не готов";
            return NotReadyId;
          default:
            //return NotFoundAnswer;
            return NotFoundId;
        }
      } else {
        //return EmptyAnswer;
        return NotFoundId;
      }
    }

    let inputText = getInput(InputId);
    let id = inputText.value;

    // let outputText = getInput(OutputId);
    // if (outputText !== undefined) {
    //   outputText.value = produceAnswer(statuses, id);
    //   outputText.classList.remove("hidden", "hide");
    // } else {
    //   alert(outputText);
    // }
  }
}

function SupressSubmit(form, event) {
  if (form.checkValidity()) {
    event.preventDefault();
  }
}
